
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export enum Size {
  S = "small",
  M = "medium",
  L = "large"
}
const SizeToRatio = {
  [Size.S]: 1,
  [Size.M]: 1.2,
  [Size.L]: 1.5
};
export default class Avatar extends Vue {
  @Prop({ type: String }) image = "";
  @Prop({ type: String, default: "medium" }) size: Size = Size.M;
  @Prop({ type: Boolean, default: true }) clickable = true;
  get ratio() {
    return SizeToRatio[this.size];
  }
}
